/* eslint-disable jsx-a11y/iframe-has-title */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Header from './sub_components/main/header'
import Footer from './sub_components/main/footer'
import Toast from './sub_components/toast';
import * as casinoService from '../services/casinoService'
import * as analysisService from '../services/analysisService'
import Casinoanalysisusersnewiframe from './casinoanalysisusersnewiframe';
let casinoBetsInterval = null;
class CasinoAnalysisUsersNew extends Component {
   constructor(props) {
      super(props);
      this.state = {
         uid: "",
         passcode: "",
         showPopupBets: false,
         showPopupUserBook: false,
         showPopupBetsLock: false,
         showPopupFancyBook: false,
         showBetsLockMenu: false,
         showFancyLockMenu: false,
         showMarketBetDetail: false,
         showUserDetailPopup: false,
         betsClientsIP: "",
         betsAmountFrom: "",
         betsAmountTo: "",
         userBetDelay: "",
         masterPassword: "",
         userBetLock: false,
         marketBetDetail: [],
         marketuserDetail: [],
         userDetail: [],
         usermktData: {},
         eventData: {},
         fancyMarkets: [],
         lineMarkets: [],
         oddsMarkets: [],
         matched_bet: [],
         matched_bet_filter: [],
         showExpo: false,
         lineExpo: {},
         tvUrl: "",
         toastMsg: "",
         toastType: "",
         showToast: false,
         bets_data: [],
         accounts: "",
         frontData: {},
         betListLimit: 20,
         // casinoUrl: "",
         betsData: [],
         runner_exposure: {},
			isCasinoAnaUserMounted: false
      };
   }
   async componentDidMount() {
      this.setState({isCasinoAnaUserMounted : true},()=>{
			this.dataBuilder()
		})
   }
   dataBuilder() {
      const self = this;

      let userData = localStorage.getItem("tokenData")
      userData = JSON.parse(userData)
      if (!(!!userData && !!userData.sub)) {
         localStorage.clear();
         this.props.history.push("/auth")
      }
      // let casinoData = await casinoService.casinoLaunch(this.props.match.params.casinoId)
      // let betsData = await analysisService.getCasinoBets(this.props.match.params.casinoId)
      analysisService.getCasinoBets(this.props.match.params.casinoId).then((res) => {
         self.setState({ betsData: res.isSuccess ? res.items : [] }, () => {

            // self.calculateExpo(self.state.betsData)

            let expo = {}
            let profileData = localStorage.getItem("tokenData")
            profileData = JSON.parse(profileData)
            let userName = profileData.sub
            let bets = self.state.betsData
            Array.prototype.forEach.call(bets, (bet, i) => {
               let sharing = bet.parentSharing.filter((user) => {
                  return user.username === userName
               })[0]
               if (!!expo[bet.runnerName]) {
      
                  if (bet.side.toString() === "0") {
      
                     expo[bet.runnerName].pProfit += bet.amount * parseFloat(sharing.sharing / 100)
                     expo[bet.runnerName].expo += (0 - ((bet.price - 1) * bet.amount)) * parseFloat(sharing.sharing / 100)
                  }
                  else if (bet.side.toString() === "1") {
                     expo[bet.runnerName].pProfit += ((bet.price - 1) * bet.amount) * parseFloat(sharing.sharing / 100)
                     expo[bet.runnerName].expo += (0 - bet.amount) * parseFloat(sharing.sharing / 100)
                  }
               } else {
      
                  if (bet.side.toString() === "0") {
                     expo[bet.runnerName] = {
                        "pProfit": bet.amount * parseFloat(sharing.sharing / 100),
                        "expo": (0 - ((bet.price - 1) * bet.amount)) * parseFloat(sharing.sharing / 100)
                     }
                  }
                  else if (bet.side.toString() === "1") {
                     expo[bet.runnerName] = {
                        "pProfit": (bet.price - 1) * bet.amount * parseFloat(sharing.sharing / 100),
                        "expo": (0 - bet.amount) * parseFloat(sharing.sharing / 100)
                     }
                  }
               }
            });
            self.setState({ runner_exposure: expo },()=>{
               self.dataBuilderIntervalCall();
            })

         })
      })
      
   }

   dataBuilderIntervalCall(){
      const self = this;
      casinoBetsInterval = setInterval(async function getBetsData() {
         clearInterval(casinoBetsInterval)
         // let betsData = await analysisService.getCasinoBets(self.props.match.params.casinoId)
         analysisService.getCasinoBets(self.props.match.params.casinoId).then((res) => {
            let betsData = res;
            if(self.state.isCasinoAnaUserMounted){
               self.setState({ betsData: betsData.isSuccess ? betsData.items : [] }, () => {
                  // self.calculateExpo(self.state.betsData)
                  let bets = self.state.betsData;
                  let expo = {}
                  let profileData = localStorage.getItem("tokenData")
                  profileData = JSON.parse(profileData)
                  let userName = profileData.sub
            
                  Array.prototype.forEach.call(bets, (bet, i) => {
                     let sharing = bet.parentSharing.filter((user) => {
                        return user.username === userName
                     })[0]
                     if (!!expo[bet.runnerName]) {
            
                        if (bet.side.toString() === "0") {
            
                           expo[bet.runnerName].pProfit += bet.amount * parseFloat(sharing.sharing / 100)
                           expo[bet.runnerName].expo += (0 - ((bet.price - 1) * bet.amount)) * parseFloat(sharing.sharing / 100)
                        }
                        else if (bet.side.toString() === "1") {
                           expo[bet.runnerName].pProfit += ((bet.price - 1) * bet.amount) * parseFloat(sharing.sharing / 100)
                           expo[bet.runnerName].expo += (0 - bet.amount) * parseFloat(sharing.sharing / 100)
                        }
            
                        // expo[bet.runner_name].expo = parseFloat(expo[bet.runner_name].expo) + (0-parseFloat(parseFloat(bet.potential_profit) * parseFloat(sharing.sharing/100)))
                        // expo[bet.runner_name].pProfit = parseFloat(expo[bet.runner_name].pProfit) + (0-parseFloat(parseFloat(0 - bet.amount) * parseFloat(sharing.sharing/100)))
                     } else {
            
                        if (bet.side.toString() === "0") {
                           expo[bet.runnerName] = {
                              "pProfit": bet.amount * parseFloat(sharing.sharing / 100),
                              "expo": (0 - ((bet.price - 1) * bet.amount)) * parseFloat(sharing.sharing / 100)
                           }
                        }
                        else if (bet.side.toString() === "1") {
                           expo[bet.runnerName] = {
                              "pProfit": (bet.price - 1) * bet.amount * parseFloat(sharing.sharing / 100),
                              "expo": (0 - bet.amount) * parseFloat(sharing.sharing / 100)
                           }
                        }
            
                        // expo[bet.runner_name] = {
                        //    "pProfit": 0-(parseFloat(parseFloat(0 - bet.amount) * parseFloat(sharing.sharing/100))),
                        //    "expo": 0-(parseFloat(parseFloat(bet.potential_profit) * parseFloat(sharing.sharing/100)))
                        // }
                     }
                  });
                  if(self.state.isCasinoAnaUserMounted){
                     self.setState({ runner_exposure: expo },()=>{
                        casinoBetsInterval = setInterval(getBetsData(), 3000)
                     })
                  }
               })
            }
         })
      }, 5000)
   }

   componentWillUnmount() {
		this.state.isCasinoAnaUserMounted = false;
      clearInterval(casinoBetsInterval)
   }
   calculateExpo(bets) {
      let expo = {}
      let profileData = localStorage.getItem("tokenData")
      profileData = JSON.parse(profileData)
      let userName = profileData.sub

      Array.prototype.forEach.call(bets, (bet, i) => {
         let sharing = bet.parentSharing.filter((user) => {
            return user.username === userName
         })[0]
         if (!!expo[bet.runnerName]) {

            if (bet.side.toString() === "0") {

               expo[bet.runnerName].pProfit += bet.amount * parseFloat(sharing.sharing / 100)
               expo[bet.runnerName].expo += (0 - ((bet.price - 1) * bet.amount)) * parseFloat(sharing.sharing / 100)
            }
            else if (bet.side.toString() === "1") {
               expo[bet.runnerName].pProfit += ((bet.price - 1) * bet.amount) * parseFloat(sharing.sharing / 100)
               expo[bet.runnerName].expo += (0 - bet.amount) * parseFloat(sharing.sharing / 100)
            }

            // expo[bet.runner_name].expo = parseFloat(expo[bet.runner_name].expo) + (0-parseFloat(parseFloat(bet.potential_profit) * parseFloat(sharing.sharing/100)))
            // expo[bet.runner_name].pProfit = parseFloat(expo[bet.runner_name].pProfit) + (0-parseFloat(parseFloat(0 - bet.amount) * parseFloat(sharing.sharing/100)))
         } else {

            if (bet.side.toString() === "0") {
               expo[bet.runnerName] = {
                  "pProfit": bet.amount * parseFloat(sharing.sharing / 100),
                  "expo": (0 - ((bet.price - 1) * bet.amount)) * parseFloat(sharing.sharing / 100)
               }
            }
            else if (bet.side.toString() === "1") {
               expo[bet.runnerName] = {
                  "pProfit": (bet.price - 1) * bet.amount * parseFloat(sharing.sharing / 100),
                  "expo": (0 - bet.amount) * parseFloat(sharing.sharing / 100)
               }
            }

            // expo[bet.runner_name] = {
            //    "pProfit": 0-(parseFloat(parseFloat(0 - bet.amount) * parseFloat(sharing.sharing/100))),
            //    "expo": 0-(parseFloat(parseFloat(bet.potential_profit) * parseFloat(sharing.sharing/100)))
            // }
         }
      });
      this.setState({ runner_exposure: expo })
   }
   render() {
      return (
         <div className="bethubs">
            <Header history={this.props.history} />
            <div className="wrapper">
               <div className="container-fluid container-padding-0">
                  <div className="row">
                     <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                        <div className="main-box">
                           <div className="row analysis-running-market mt-1">
                              <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                 <div className={"casinoLeftSide"}>
                                 </div>
                                 <div className="main-analysis mb-2 casinobetmobileshow" >
                                    <div className="top">
                                       <div className="w-100">
                                          <div className="marketanlytitle">Book <a href="#casinobets" className="bk-btn casinoviewbetsbtn" >View Bets</a></div>
                                       </div>
                                    </div>
                                    <div className="table-responsive  max-hight">
                                       <table className="w-100 table-sm font-14 text-black table-striped table-bordered">
                                          <tbody>
                                             {Object.keys(this.state.runner_exposure).length > 0 ? Object.keys(this.state.runner_exposure).map((rnr, i) => {
                                                let expo = this.state.runner_exposure[rnr].expo
                                                let pProf = this.state.runner_exposure[rnr].pProfit
                                                return <tr>
                                                   <td>{rnr}</td>
                                                   <td className={pProf < 0 ? "fbold text-red" : "fbold text-green"}>{pProf.toFixed(2)}</td>
                                                   <td className={expo < 0 ? "fbold text-red" : "fbold text-green"}>{expo.toFixed(2)}</td>
                                                </tr>
                                             }) : <tr><td >No Book Found.</td></tr>}
                                          </tbody>
                                       </table>
                                    </div>
                                 </div>
                                 <div>
                                    <Casinoanalysisusersnewiframe casinoId={this.props.match.params.casinoId}/>
                                 </div>
                                 <div className={"casinoRightSide"} id="casinobets">
                                    <div className="main-analysis mb-2 casinobetmobilehide">
                                       <div className="top">
                                          <div className="w-100">
                                             <div className="marketanlytitle">Book</div>
                                          </div>
                                       </div>
                                       <div className="table-responsive  max-hight">
                                          <table className="w-100 table-sm font-14 text-black table-striped table-bordered">
                                             <tbody>
                                                {Object.keys(this.state.runner_exposure).length > 0 ? Object.keys(this.state.runner_exposure).map((rnr, i) => {
                                                   let expo = this.state.runner_exposure[rnr].expo
                                                   let pProf = this.state.runner_exposure[rnr].pProfit
                                                   return <tr>
                                                      <td>{rnr}</td>
                                                      <td className={pProf < 0 ? "fbold text-red" : "fbold text-green"}>{pProf.toFixed(2)}</td>
                                                      <td className={expo < 0 ? "fbold text-red" : "fbold text-green"}>{expo.toFixed(2)}</td>
                                                   </tr>
                                                }) : <tr><td >No Book Found.</td></tr>}
                                             </tbody>
                                          </table>
                                       </div>
                                    </div>
                                    <div className="main-analysis mb-2">
                                       <div className="table-responsive  max-hight">
                                          <table className="w-100 table-sm font-12 text-black">
                                             <thead className="">
                                                <tr className="bg-dark text-white bg-dark1">
                                                   <td>UserName</td>
                                                   <td>Market</td>
                                                   <td>Runner</td>
                                                   <td>Rate</td>
                                                   <td>Amount</td>
                                                </tr>
                                             </thead>
                                             <tbody>
                                                {this.state.betsData.length > 0 ? this.state.betsData.map((bet, i) => {
                                                   return <tr ket={"casana_usr_tr" + i} bgcolor={bet.side === 0 ? "#72BBEF" : bet.side === 1 ? "#FAA9BA" : ""} >
                                                      <td>{bet.username ? bet.username : "-"}</td>
                                                      <td>{!!bet.marketName ? bet.marketName : "-"}</td>
                                                      <td>{!!bet.runnerName ? bet.runnerName : "-"}</td>
                                                      <td className="fbold">{!!bet.price ? bet.price : "0.00"} </td>
                                                      <td className="fbold">{!!bet.amount ? bet.amount.toFixed(2) : "0.00"}</td>
                                                   </tr>
                                                }) : <tr><td colSpan={5}>No Bets Found.</td></tr>}
                                             </tbody>
                                          </table>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                              <div className="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">

                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
            {!!this.state.showToast && <Toast notification={this.state.toastMsg} type={this.state.toastType} />}
            <Footer />
         </div>
      )
   }
}
function mapStateToProps(state) {
   return {
   };
}
function mapDispatchToProps(dispatch) {
   return {
   };
}
export default connect(mapStateToProps, mapDispatchToProps)(CasinoAnalysisUsersNew);